<template v-if="globaljs.mb_staff !== 'Worker'">
	<include-header />

	<section id="lab_manage_partner">
		<div class="content">
			<div class="contIn">
				<div class="sub_cont">
					<div class="boardTit">거래처 관리</div>
					<div class="sub_contBox">
						<div class="set_tabWrap">
							<div class="set_tabTit">
								<ul class="set_tab">
									<li>
										<router-link to="/manage_partner">매칭 거래처</router-link>
									</li>
									<li class="active">
										<router-link to="/unmatched_partner">대기중 거래처</router-link>
									</li>
								</ul>
							</div>
							<button type="button" class="printBtn" id="manage_add_btn"
								@click="commonjs.pagePopup('/partner_add', 'partner_add')">등록</button>
						</div>

						<div class="subTitWrap">
							<div class="subTit">[대기중 거래처 목록]</div>
						</div>

						<form ref="form_search" id="form_search" @submit.prevent="getModels()">
							<div class="searchRow">
								<!--
								<div class="searchCont">
									<label for="category" class="form-label required">구분</label>
									<select v-model="searchModels.type" id="type">
										<option value="">전체</option>
										<option value="send">요청보냄</option>
										<option value="recv">요청받음</option>
									</select>
								</div>
								-->
								<div class="searchCont">
									<label for="category" class="form-label required">검색어</label>
									<select v-model="searchModels.category" id="category">
										<option value="mb_nick">{{ other_type }}</option>
										<option value="mb_tel">대표전화번호</option>
										<option value="mb_hp">휴대폰번호</option>
										<option value="mb_busi_num">사업자번호</option>
									</select>
									<input name="keyword" type="text" v-model="searchModels.keyword" placeholder="검색어 입력">
								</div>
								<div class="searchCont">
									<label for="orderDateSearch" class="form-label required">요청일</label>
									<input type="date" class="form-control" id="sendDateSearch"
										v-model="searchModels.sendDateSearch" value="">
									<span class="hyphen">-</span>
									<input type="date" class="form-control" id="sendDateSearch2"
										v-model="searchModels.sendDateSearch2" value="">
								</div>
								<div>
									<button type="button" class="search_btn" id="searchBtn"
										@click.prevent="getModels()">검색</button>
									<button type="button" v-show="isSearchActive" class="search_btn reset_btn" @click="searchReset()">초기화</button>
								</div>
							</div>
						</form>

						<form ref="form_unmatched_batch" id="form_unmatched_batch"
							:action="`${SERVER_URL}/api/app/matching/del`" @submit.prevent="form_unmatched_one_submit()"
							method="post" autocomplete="off">
							<DataTable :headers="headers" :itemsData="items" :perPage="10" :hasCheck="true"
								:showNum="false" :actionBatch="true" checkedField="partner.mb_boss_id"
								:dateFormat="'YYYY-MM-DD HH:mm:ss'" :dateTarget="'send_datetime'"
								@manage="form_unmatched_one_submit" @manageBatch="form_unmatched_batch_submit" />
						</form>
					</div>
				</div>
			</div>
		</div>
	</section>

	<include-footer />
</template>

<script>
import header from '../components/layout/header.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import DataTable from '@/components/layout/DataTable';

const route = useRoute();
const router = useRouter();

if(globaljs.mb_staff === 'Worker') { commonjs.authSwal(); }

const today = moment().format('YYYY-MM-DD');

let other_type = ref(null);
if (globaljs.acc_type === 'lab') {
	other_type.value = "치과";
} else {
	other_type.value = "기공소";
}

const items = ref([]);

const headers = ref([]);
headers.value = [
	//{ label: '요청/수신일', key: 'request_recv_date' },
	{ label: '요청일시', key: 'send_datetime' },
	{ label: other_type, key: 'partner.mb_nick' },
	{ label: '대표 전화번호', key: 'partner.mb_tel' },
	{ label: '휴대전화', key: 'partner.mb_hp' },
	{ label: '사업자번호', key: 'partner.mb_busi_num' },
	{ label: '관리', key: 'manage' }
];


//:dateTarget="item => item.isSend ? 'send_datetime' : 'recv_datetime'"
const status_txt = ref('');

// 예시 데이터 설정
// items.value = [
// { 'partner.mb_nick': '깨끗한이치과', 'partner.mb_tel': '051-12-1234', 'partner.mb_hp': '010-1111-0320', 'partner.mb_busi_num': '555-55-55555', createdAt: '2024-05-29' }
// ];

onMounted(async () => {
	if(globaljs.mb_staff !== 'Worker') { 
		await getModels();
	}
});


let form_search = ref(null)
let searchModels = ref({
	//type: '',
	category: 'mb_nick'
});

// 초기화 함수
const searchReset = async () => {
	searchModels.value = Object.assign({});
	form_search.value.reset();
	document.querySelectorAll('form#form_search select').forEach(function (selectElement) {
		selectElement.value = '';
		selectElement.selected = true;
	});
	searchModels.value.category = 'mb_nick';

	await getModels();
}

// 하나라도 검색 조건이 지정되어 있는지 확인
const isSearchActive = computed(() => {
	return Object.values(searchModels.value).some(value => value !== '');
});

const getModels = async () => {
	const params = new URLSearchParams();
	// params.append('mb_id', globaljs.mb_id);
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);

	if (searchModels.value != undefined) {
		Object.keys(searchModels.value).map(v => {
			params.append(v, searchModels.value[v]);
		});
	}

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	try {
		let response = await axios.get(`${SERVER_URL}/api/app/matching/unmatched`, { params });
console.debug(response.data.result);
		items.value = response.data.result;
	} catch (error) {
console.error('Error getModels:', error);
	}
}

window.getModels = getModels;

async function form_unmatched_one_submit(id, other_mb_id, other_nick, action) {
	if (action === 'cancel') {
		status_txt.value = '취소';
	} else if (action === 'accept') {
		status_txt.value = '수락';
	} else if (action === 'reject') {
		status_txt.value = '거절';
	}

	const is_confirm = await commonjs.confirmSwal('매칭처리 확인', `[${other_nick}] 매칭을 ${status_txt.value}하시겠습니까?`);
	if (!is_confirm) {
		return false;
	}

	const params = new URLSearchParams();
	// params.append('mb_id', globaljs.mb_id);
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
	params.append('other_mb_id', other_mb_id);
	params.append('id', id);
	params.append('action', action);

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	await axios
	.put(`${SERVER_URL}/api/app/matching/unmatched`, params)
	.then((response) => {
console.debug(response.data.result);
		getModels();

		toast.fire({
			icon: "success",
			title: `[${other_nick}] 매칭 ${status_txt.value} 성공했습니다.`
		});
	})
	.catch((error) => {
console.error(error?.response?.data);
		commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
	});
}

async function form_unmatched_batch_submit(other_mb_ids, action) {
//console.log(action);
	if (action === 'cancel') {
		status_txt.value = '취소';
	} else if (action === 'accept') {
		status_txt.value = '수락';
	} else if (action === 'reject') {
		status_txt.value = '거절';
	}
//console.debug( other_mb_ids );
	const params = new URLSearchParams();
	params.append('mb_boss_id', globaljs.mb_boss_id);
	params.append('acc_type', globaljs.acc_type);
	//params.append('mb_level', globaljs.mb_level);
	other_mb_ids.forEach(other_id => {
//console.debug( other_id );
		// 240902 other_id를 보내면? 또는 other_mb_ids를 그냥 보내면?
		params.append('ids[]', other_id.id);
		params.append('other_mb_ids[]', other_id.partner.mb_boss_id);
	});
	params.append('action', action);

	// URLSearchParams를 객체로 변환
	const object = {};
	params.forEach((value, key) => {
		if (key.endsWith('[]')) {
			const arrayKey = key.slice(0, -2);
			if (!object[arrayKey]) {
				object[arrayKey] = [];
			}
			object[arrayKey].push(value);
		} else {
			object[key] = value;
		}
	});

	// 결과 확인용 로그 출력
	const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
console.info(jsonString);

	await axios
	.put(`${SERVER_URL}/api/app/matching/unmatched/multi`, params)
	.then((response) => {
console.debug(response.data.result);
		getModels();

		toast.fire({
			icon: "success",
			title: `매칭 ${status_txt.value} 성공했습니다.`
		});
	})
	.catch((error) => {
console.error(error?.response?.data);
		commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
	});
}
</script>